import { css } from '@emotion/react';

import { color } from '@skippay/core/styles/variables';

const lightGray400 = color('light-gray-400');
const blue500 = color('blue-500');
const white = color('white');

export const primary = css`
	background: ${color('green-600')};
	color: ${white};
	/* overwrite default browser behaviour */
	&:hover,
	&:active {
		color: ${white};
	}
	@media (hover: hover) {
		&:hover {
			background: ${color('green-700')};
		}

		&:active {
			background: ${color('green-900')};
		}
	}
	&[disabled] {
		background: ${color('green-200')};
		color: ${white};
	}
`;

export const secondary = css`
	background: transparent;
	color: ${color('gray-900')};
	border-color: ${lightGray400};
	/* overwrite default browser behaviour */
	&:hover,
	&:active {
		color: ${color('gray-900')};
	}
	@media (hover: hover) {
		&:hover {
			background: ${lightGray400};
			border-color: ${lightGray400};
			color: ${white};
		}

		&:active {
			background: ${color('light-gray-600')};
			border-color: ${color('light-gray-600')};
			color: ${white};
		}
	}
	&[disabled] {
		background: ${color('light-gray-200')};
		border-color: ${color('light-gray-200')};
		color: ${white};
	}

	.dark & {
		background: transparent;
		color: ${white};
		border-color: ${white};
		/* overwrite default browser behaviour */
		&:hover,
		&:active {
			color: ${white};
		}
		@media (hover: hover) {
			&:hover {
				background: ${white};
				border-color: ${white};
				color: ${color('gray-900')};
			}

			&:active {
				background: ${color('gray-900')};
				border-color: ${white};
			}
		}

		&[disabled] {
			background: transparent;
			border-color: ${white};
			color: ${white};
			opacity: 0.5;
		}
	}
`;

export const info = css`
	background: transparent;
	color: ${blue500};
	border-color: ${blue500};
	/* overwrite default browser behaviour */
	&:hover,
	&:active {
		color: ${blue500};
	}
	@media (hover: hover) {
		&:hover {
			background: ${white};
			border-color: ${blue500};
		}

		&:active {
			background: ${blue500};
			border-color: ${blue500};
			color: ${white};
		}
	}
	&[disabled] {
		color: ${color('blue-200')};
		border-color: ${color('blue-200')};
	}
`;

export const danger = css`
	background: ${color('red-500')};
	color: ${white};
	/* overwrite default browser behaviour */
	&:hover,
	&:active {
		color: ${white};
	}
	@media (hover: hover) {
		&:hover {
			background: ${color('red-600')};
		}

		&:active {
			background: ${color('red-800')};
		}
	}

	&[disabled] {
		color: ${white};
		background: ${color('red-200')};
	}
`;

export const warning = css`
	background: ${color('orange-500')};
	color: ${white};
	/* overwrite default browser behaviour */
	&:hover,
	&:active {
		color: ${white};
	}
	@media (hover: hover) {
		&:hover {
			background: ${color('orange-600')};
		}

		&:active {
			background: ${color('orange-800')};
		}
	}

	&[disabled] {
		color: ${white};
		background: ${color('orange-200')};
	}
`;
